
// In base allo stato dell'header e alle opzioni scelte su prismic, restituisce un oggetto con tutte le classi del tema, usabile sia desktop che mobile
export function getHeaderTheme(themeFromPrismic, isTransparent, isTopOfThePage, isMenuOpen) {
  const bgColor = getBgColor(themeFromPrismic, isTransparent, isTopOfThePage, isMenuOpen)
  const theme = getTheme(themeFromPrismic, bgColor)

  return {
    theme: theme,
    bgColor: bgColor,
    transitions: 'transition-all ease-in-out duration-200',
    textColor: theme === 'light' ? 'text-midnight-10' : 'text-white',
    vectorFill: theme === 'light' ? 'fill-blue-10' : 'fill-white',
    vectorStroke: theme === 'light' ? 'stroke-midnight-10' : 'stroke-white',
  }
}

// In base allo stato dell'header, restituisce il colore del suo sfondo
function getBgColor(theme, isTransparent, isTopOfThePage, isMenuOpen) {
  if (isTransparent && isTopOfThePage && !isMenuOpen) {
    return 'bg-transparent'
  } else if (theme === 'light' || isMenuOpen || !isTopOfThePage) {
    return 'bg-white'
  } else {
    return theme === 'dark' ? 'bg-midnight-10' : 'bg-white'
  }
}

// In base allo sfondo dell'header, restituisce quale tema (light/dark) va usato
function getTheme(theme, bgColor) {
  switch (bgColor) {
    case 'bg-transparent':
      return theme
    case 'bg-white':
      return 'light'
    default:
      return 'dark'
  }
}